import { app } from '../../../bootstrap/core';
import { confirmFinancesComponent } from './confirmFinances.component';
import { ConfirmFinancesService } from './confirmFinances.service';
import {
  FinanceTypes,
  FinanceTypeDocuments,
  FinanceSequencyTypes,
  FinanceIntervalTypes,
  FinanceDirectDebitProperties,
  FinanceReceivedPaymentProperties,
  FinanceStandingOrdersProperties
} from './confirmFinances.constants';
import '../../../common/ui/ticket/financeList/financeList';
import financesDirectDebitsTemplate from './partials/confirmFinances.directDebits.tpl.html';
import financesReceivedPaymentTemplate from './partials/confirmFinances.receivedPayments.tpl.html';
import financesStandingOrdersTemplate from './partials/confirmFinances.standingOrders.tpl.html';

app.component('confirmFinances', confirmFinancesComponent);
app.service('confirmFinancesService', ConfirmFinancesService);
app.constant('FinanceTypes', FinanceTypes);
app.constant('FinanceTypeDocuments', FinanceTypeDocuments);
app.constant('FinanceSequencyTypes', FinanceSequencyTypes);
app.constant('FinanceIntervalTypes', FinanceIntervalTypes);
app.constant('FinanceDirectDebitProperties', FinanceDirectDebitProperties);
app.constant('FinanceReceivedPaymentProperties', FinanceReceivedPaymentProperties);
app.constant('FinanceStandingOrdersProperties', FinanceStandingOrdersProperties);
app.value('financesDirectDebitsTemplate', financesDirectDebitsTemplate);
app.value('financesReceivedPaymentTemplate', financesReceivedPaymentTemplate);
app.value('financesStandingOrdersTemplate', financesStandingOrdersTemplate);
